import { isEmpty } from 'lodash';
import checkIsVariantEnabled from './checkIsVariantEnabled';

// get the variant values from the form
// delete any variant values that are not visible
// gets the optionId for the first selected option
export default function getFormVariantValues(variants, formVariants) {
  if (isEmpty(formVariants) || !variants || !Array.isArray(variants)) return {};

  const formVariantValues = Object.entries(formVariants).reduce(
    (obj, [variantId, selectedOptions]) => {
      const variant = variants.find(variant => variant._id === variantId);

      if (!variant) return obj;

      // we need to unset any that is not visible
      const visible = checkIsVariantEnabled(variant, formVariants, variants);

      if (!visible) {
        delete obj[variantId];
      } else {
        if (variant.selectionType === 'quantity' || variant.selectionType === 'multiple') {
          const selectedOptionsWithQuantity = selectedOptions.filter(option => option.quantity > 0);

          obj[variantId] = selectedOptionsWithQuantity;
        } else {
          obj[variantId] = selectedOptions[0]?.optionId || null;
        }
      }

      return obj;
    },
    {},
  );

  return formVariantValues;
}
